





















































































































































































import { PageMode } from '@/main/utils/pageMode';
import { openEdit } from '@/main/router/routerPath';
import { genVuexComputeds } from '@/main/pages/editFactory';
import { EditStoreMixin } from '@/main/pages/editStoreMixin';
import { Column, Table, Row, EditableStatus } from '@/main/utils/table';
import _ from 'lodash';

import { END_LOADING, START_LOADING, TABLE_DATA } from '@/main/store/listEditTypes';

import { apiProvider as partApiProvider } from '@/modules/servis/rezervaceND/api';

import { isUserPartsManager, OpenPartMaintenance } from '@/main/utils/commonFunctions';

import DmsEditableTable from '#components/dms/layout/EditableTable.vue';


import { apiProvider as OZakazkaProvider } from '../../api';
import { NAME , DefualtQuantity, PART_ROW_SAVED, PART_ROW_EDITED, PART_STOCK_SELECTED, PART_SELECTED } from '../constants';
import { ND, ND_COLS, MIN_DISCOUNT_LIMIT, MAX_DISCOUNT_LIMIT, UOM, PLANNED_ORDER_PARTS_ROW_LENGTH} from '../../constants';
import { store } from '../../store/edit';


export default EditStoreMixin.extend({
	name: 'OZakazkaNDTable',
	components: {
		DmsEditableTable,
	},
	data() {
		return {
			technicianId: 0,
			loadingDropdown: false,
			descriptionInput: '',
			baseUnitOfMeasurement: '',
			convertedQuantity: 0,
			expandedUnit: '',
			cancelDescriptionInput: '',
			localRrpInput: '',
			canceLocalRrpInput: '',
			rrpUnitPriceInput: '',
			cancelRrpunitPriceInput: '',
			ndpInput: '',
			cancelNdpInput: '',
			pcInput: '',
			stockInput: '',
			brandInput: '',
			cancelStockInput: '',
			showDiscountDialog: false,
			isDNPEditable: false,
			cancelPcInput: '',
			ndNrInput: '',
			columns: new Set([
				'X_VYROBEKND_OZN',
				'ND_NR',
				'LOCAL_RRP_ID',
				'UNIT_PRICE_',
				'NDP',
				'TEXT',
				'BASE_UNIT_OF_MEASUREMENT',
				'RRP_UNIT_PRICE',
				'CONVERTED_QUANTITY',
				'POPTAVKA',
				'MNOZSTVI_VYDANO',
				'MNOZSTVI_SJ',
				'MNOZSTVI_SJ_KOR',
				'MNOZSTVI_ZBYVA',
				'MNOZSTVI_REZ',
				'MNOZSTVI_DISP',
				'MNOZSTVI_DISP_ESHOP',
				'PC_JDN_ZKR',
				'PC_CELK',
				'VIN_BASED_DISC',
				'SEGMENT_BASED_DISC',
				'PC_SLEVA_PO',
				'SKLADY_VYSK_PLUS2',
				'VYROBEKND_OZN',
				'ZBYVA_VYDAT',
				'PC',
				'PC_WITH_GST',
				'PC_IGST',
				'PC_CGST',
				'PC_SGST',
				'PC_UTGST',
				'HSN_CODE',
				'PC_PERCENTAGE',
				'CESS',
				'VALUE',
				'SLEVA',
				'PERCENTAGE',
			]),
			ND,
			ndCols: ND_COLS,
			selectedPartNumber: '',
			previousPartNumber: '',
			isPartSelectionInProgress: false,
			timeout: null as any | null,
		};
	},
	computed: {
		isUserPartsManager(): boolean {
			return isUserPartsManager(this.pracovnik.PracovnikOzn, this.userRoles);
		},
		watchlistCheck() : boolean | null {
			return this.WatchlistFlag;
		},
		NahradniDilyTable(): any {
			const copy = _.cloneDeep(this.dependentTables.NahradniDily);
			this.disableColumns(copy);
			return copy;
		},
		...genVuexComputeds(store),
	},
	watch: {
		selectedPartNumber(newValue: any) {
		},
	},
	methods: {
		onPartNumberClick(row: Row) {
			OpenPartMaintenance({ cellNames: this.dependentTables.NahradniDily.cellNames, row });
		},
		async toggleDiscountDialog() {
			this.showDiscountDialog = !this.showDiscountDialog;
		},
		async onCheckClick(event: any) {
			clearTimeout(this.timeout);
			this.timeout = setTimeout(() => {
				if (event.target.value.length > 2) {
					this.dropdownList.Parts = this.dropdownList.DefaultPartsList.filter((item: any) => item.Text.includes(event.target.value.toUpperCase()));
				} else {
					this.dropdownList.Parts = this.dropdownList.DefaultPartsList.slice(0, 100);
				}
			}, 800);
		},
		async stockChangeMethod(val: string, row: Row) {
			const startTime = performance.now();
			const brandIndex: number = this.dependentTables.NahradniDily.cellNames?.VYROBEKND_OZN!;
			row.cells[brandIndex] = '';
			this.clearRow(row);
			const loading = this.$loading({ fullscreen: true });
			if ((this.DefaultWarehouseId!.toString() == val)) {
				this.stockInput = val;
				this.dropdownList.DefaultPartsList = this.dropdownList.InitialPartsLoadList;
				this.dropdownList.Parts = this.dropdownList.DefaultPartsList.slice(0, 100);
			} else if (val !== this.DefaultWarehouseId!.toString()) {
				this.stockInput = val;
				const stockIndex: number = this.dependentTables.NahradniDily.cellNames!.STOCK;
				row.cells[stockIndex] = val;

				const { data: result } = await OZakazkaProvider.getPartsList(this.VehicleBrand!, row.cells[stockIndex], '');
				this.dropdownList.DefaultPartsList = result.DropDownList.partsList;
				this.dropdownList.Parts = this.dropdownList.DefaultPartsList.slice(0, 100);
			}
			const{data: isDealer} = await OZakazkaProvider.checkIsDealerCustomer(this.OzakazkaId);
            this.isDNPEditable = isDealer;
			loading.close();
			let iTotalTimeTaken = performance.now() - startTime;
			let seconds = parseFloat((iTotalTimeTaken / 1000).toFixed(2));
			await OZakazkaProvider.logPerformance('PlannedOrderPrp', `Planned Order: ${this.OzakazkaId!}`, PART_STOCK_SELECTED, seconds);
		},
		clearRow(row: Row) {
			const descriptionIndex: number = this.dependentTables.NahradniDily.cellNames?.TEXT!;
			row.cells[descriptionIndex] = '';
			const unitIndex: number = this.dependentTables.NahradniDily.cellNames?.BASE_UNIT_OF_MEASUREMENT!;
			row.cells[unitIndex] = '';
			const qtyIndex: any = this.dependentTables.NahradniDily.cellNames?.PART_QUANTITY;
			row.cells[qtyIndex] = '';
			const localRRPIndex: number = this.dependentTables.NahradniDily.cellNames?.LOCAL_RRP_ID!;
			row.cells[localRRPIndex] = '';
			const serviceJobIndex: number = this.dependentTables.NahradniDily.cellNames?.SERVICE_JOB_ID!;
			row.cells[serviceJobIndex] = '';
			const discountIndex: any = this.dependentTables.NahradniDily.cellNames?.SLEVA!;
			row.cells[discountIndex] = '0';
		},
		getstockDetails(row: Row, columnId: number) {
			const result: any = this.dropdownList.Stock.find((item: any) => item.Value === row.cells[columnId]);
			return result?.Text;
		},
		async saveDiscount() {
			if (this.TotDiscPercentParts! > MAX_DISCOUNT_LIMIT || this.TotDiscPercentParts! < MIN_DISCOUNT_LIMIT) {
				this.TotDiscPercentParts = 0;
				this.showErrorAlert({
					message: this.LocalizeChyboveHlasky('msgNotMoreDiscThn100Per'),
					options: { type: 'error' },
					localizeMessage: false,
				});
				return;
			}
			const row = { cells: [], operations: 0 } as Row;
			const isDiscountApplicable = await this.checkForDiscountLimit(false, 0, row);
			if (isDiscountApplicable) {
				this.updateDiscount();
			}
		},
		async updateDiscount() {
			this.showDiscountDialog = false;
			this.$store.commit(`${this.storeUri}/${START_LOADING}`);
			await OZakazkaProvider.updateDiscountForAllParts(this.OzakazkaId, this.TotDiscPercentParts);
			this.$store.commit(`${this.storeUri}/${END_LOADING}`);
			this.fetchTableData([ND]);
		},
		checkForDiscountLimit(Level: boolean, Sleva: any, newRow: Row) {
			if (this.dmsSys.OrderDiscountPrp !== true) return true;
			let errormsg = null;
			if (this.loggedUser.DiscountLimitConfigData === null) errormsg = this.LocalizeChyboveHlasky('msgNotPerToAplyDisc');
			else {
				if (Level) {
					this.TotDiscPercentParts = parseFloat("0");
					let count = 0;
					_.map(this.dependentTables.NahradniDily.rows, () => {
						const discountColId = this.dependentTables.NahradniDily.cellNames?.SLEVA;
						const recordId = this.dependentTables.NahradniDily.cellNames?.ND_NR;
						const lineItemDiscountValue: number = parseInt(_.defaultTo(this.dependentTables.NahradniDily.rows[count].cells[discountColId as number], 0));
						if (this.dependentTables.NahradniDily.rows[count].cells[recordId as number] !== newRow.cells[recordId as number]) {
							this.TotDiscPercentParts = parseFloat((_.defaultTo(this.TotDiscPercentParts, 0) as any) + lineItemDiscountValue);
						}
						count += 1;
					});
					const currentValue = parseFloat(Sleva);
					if (currentValue > 0) {
						this.TotDiscPercentParts = parseFloat((_.defaultTo(this.TotDiscPercentParts, 0) as any) + currentValue);
					}
			    }
				if (Level) {
					errormsg = this.validateDiscount(
						this.loggedUser.DiscountLimitConfigData.PartItemPer,
						Level,
						Sleva,
					);
				}
				if (errormsg !== null) {
					this.TotDiscPercentParts = 0;
					this.showErrorAlert({
						message: `${errormsg}${this.LocalizeAndReplace(this.LocalizePopisostatni(Level
							? 'PART_ITEM' : 'PART_ITEM_TOTAL'), { key: this.LocalizePopisostatni('Level_Limit'), value: '' }).toLowerCase()}.`,
						options: { type: 'error' },
						localizeMessage: false,
					});
					return false;
				}
				errormsg = this.validateDiscount(
					this.loggedUser.DiscountLimitConfigData.PartItemTotalPer,
					false,
					Sleva,
				);
			}
			if (errormsg !== null) {
				this.TotDiscPercentParts = 0;
				this.showErrorAlert({
					message: `${errormsg}${this.LocalizeAndReplace(this.LocalizePopisostatni(Level
						? 'PART_ITEM' : 'PART_ITEM_TOTAL'), { key: this.LocalizePopisostatni('Level_Limit'), value: '' }).toLowerCase()}.`,
					options: { type: 'error' },
					localizeMessage: false,
				});
				return false;
			}
			return true;
		},
		async fetchTableData(this: any, tablesToFetch: string[] = Object.values(this.zakazkaTables)): Promise<any> {
			const tables: [string, any][] = tablesToFetch.map((item) => [item, item]);
			return Promise.all(tables.map(([key, value]) => this.$store.dispatch(`${this.storeUri}/${value}_${TABLE_DATA}`, { filter: this[`${value}Filter`] })));
		},
		validateDiscount(discountper: number, Level: boolean, sleva: any) {
			let errormsg = null;
			if (discountper === 0) {
				errormsg = this.LocalizeChyboveHlasky('msgNotPerToAplyDisc');
				return errormsg;
			} if (!Level && this.TotDiscPercentParts === null) {
				errormsg = this.LocalizeChyboveHlasky('msgReqDiscOrValue');
				return errormsg;
			} if (discountper > 0 && discountper < (sleva === null ? 0 : sleva)) {
				errormsg = (this.LocalizeChyboveHlasky('msgNotAplyMoreThnDiscPer').replace('<DISC_PER>', `${discountper}%`));
				return errormsg;
			} if (Level && discountper > 0 && discountper < (sleva === null ? 0 : sleva)) {
				errormsg = this.LocalizeChyboveHlasky('msgNotAplyMoreThnDiscPer').replace('<DISC_PER>', `${discountper}%`);
				return errormsg;
			} if (!Level && discountper > 0 && discountper < (this.TotDiscPercentParts === null ? 0 : this.TotDiscPercentParts)) {
				errormsg = this.LocalizeChyboveHlasky('msgNotAplyMoreThnDiscPer').replace('<DISC_PER>', `${discountper}%`);
				return errormsg;
			}
			return errormsg;
		},
		async createRow() {
			if (this.dependentTables.NahradniDily.rows.length >= PLANNED_ORDER_PARTS_ROW_LENGTH) {
				const technicianIndex: number = this.dependentTables.NahradniDily.cellNames!.TECHNICIAN;
				this.technicianId = this.dependentTables.NahradniDily.rows[0].cells[technicianIndex];
			}
			this.selectedPartNumber = '';
			this.previousPartNumber = '';
			this.isPartSelectionInProgress = false;
			this.dropdownList.Parts = [];
			(this.$refs.editableTable as any).createRow();
		},
		updateRows({ rows }: { rows: Row[] }) {
			this.dependentTables.NahradniDily.rows = rows;
		},
		updateRow(rowUpdateData: { tableName: string; updateStatus: EditableStatus; rowId: number; row: Row }) {
				if (rowUpdateData.updateStatus != EditableStatus.DELETED) {
					this.$store.commit(`${this.storeUri}/updateTableRow`, rowUpdateData);
				}
		},
		async onEditRow({ rowIndex, row }: { rowIndex: number, row: Row }) {
			const startTime = performance.now();
			const technicianIndex: number = this.dependentTables.NahradniDily.cellNames!.TECHNICIAN;
			this.technicianId = row.cells[technicianIndex];
			const vyrobekndOznIndex: number = this.dependentTables.NahradniDily.cellNames!.VYROBEKND_OZN;
			const partNumberIndex: number = this.dependentTables.NahradniDily.cellNames!.ND_NR;
			const part = row.cells[partNumberIndex];
			this.selectedPartNumber = part;
			this.previousPartNumber = part;
			const warehouseIndex:number = this.dependentTables.NahradniDily.cellNames!.STOCK;
			const loading = this.$loading({ fullscreen: true });
			 if (this.OzakazkaId !== null && this.OzakazkaId !== undefined && (row.cells[warehouseIndex] !== null && row.cells[warehouseIndex] !== '' && row.cells[warehouseIndex] !== undefined)) {
				const { data: localRrpList } = await OZakazkaProvider.getPricingDate(row.cells[partNumberIndex], row.cells[vyrobekndOznIndex], this.OzakazkaId, row.cells[warehouseIndex]);
				if (localRrpList !== null || localRrpList !== undefined) {
					this.dropdownList.Mrp = localRrpList;
				}
				
			 }
			this.brandInput = row.cells[vyrobekndOznIndex];
			const textIndex: any = this.dependentTables.NahradniDily.cellNames?.TEXT;
			const pcIndex: any = this.dependentTables.NahradniDily.cellNames?.PC;
			this.descriptionInput = row.cells[textIndex];
			const unitIndex: any = this.dependentTables.NahradniDily.cellNames?.BASE_UNIT_OF_MEASUREMENT;
			this.baseUnitOfMeasurement = row.cells[unitIndex];
			this.cancelDescriptionInput = row.cells[textIndex];
			this.pcInput = row.cells[pcIndex];
			this.cancelPcInput = row.cells[pcIndex];
			const localRrpIndex: number = this.dependentTables.NahradniDily.cellNames!.LOCAL_RRP_ID;
			this.localRrpInput = row.cells[localRrpIndex];
			this.canceLocalRrpInput = row.cells[localRrpIndex];

			const rrpUnitPriceIndex: number = this.dependentTables.NahradniDily.cellNames!.RRP_UNIT_PRICE;
			this.rrpUnitPriceInput = row.cells[rrpUnitPriceIndex];
			this.cancelRrpunitPriceInput = row.cells[rrpUnitPriceIndex];


			const ndpIndex: number = this.dependentTables.NahradniDily.cellNames!.NDP;
			this.ndpInput = row.cells[ndpIndex];
			this.cancelNdpInput = row.cells[ndpIndex];
			const ndNrIndex: number = this.dependentTables.NahradniDily.cellNames!.ND_NR;
			this.ndNrInput = row.cells[ndNrIndex];
			const stockIndex: number = this.dependentTables.NahradniDily.cellNames!.STOCK;
			this.stockInput = row.cells[stockIndex];
			this.cancelStockInput = row.cells[stockIndex];	
			if(row.cells[warehouseIndex] !== '' && row.cells[warehouseIndex] !== undefined) {
				if (this.dropdownList.PartsLists.length === 0 && this.dropdownList.DefaultPartsList.length < 1) {
					this.loadingDropdown = true;
					const { data: result } = await OZakazkaProvider.getPartsList(this.VehicleBrand!, row.cells[this.dependentTables.NahradniDily.cellNames!.STOCK], '');
					if(result !== null || result !== undefined) {
						this.dropdownList.PartsLists = result.DropDownList.partsList;
						this.loadingDropdown = false;
					}
				}
			}
			loading.close();
			let iTotalTimeTaken = performance.now() - startTime;
			let seconds = parseFloat((iTotalTimeTaken / 1000).toFixed(2));
			await OZakazkaProvider.logPerformance('PlannedOrderPrp', `Planned Order: ${this.OzakazkaId!}`, PART_ROW_EDITED, seconds);
		},
		async rowSaved({ row: newRow }: { row: Row }) {
			const startTime = performance.now();
			this.$store.commit(`${this.storeUri}/${START_LOADING}`);
			const technicianIndex: number = this.dependentTables.NahradniDily.cellNames!.TECHNICIAN;
			newRow.cells[technicianIndex] = this.technicianId;
			const stockIndex: number = this.dependentTables.NahradniDily.cellNames!.STOCK;
			newRow.cells[stockIndex] = this.stockInput;
			const priceIndex: number = this.dependentTables.NahradniDily.cellNames!.LOCAL_RRP_ID;
			newRow.cells[priceIndex] = this.localRrpInput;
			const rrpUnitPriceIndex: number = this.dependentTables.NahradniDily.cellNames!.RRP_UNIT_PRICE;
			newRow.cells[rrpUnitPriceIndex] = this.rrpUnitPriceInput;
			const textIndex: any = this.dependentTables.NahradniDily.cellNames?.TEXT;
			newRow.cells[textIndex] = this.descriptionInput;
			const pcIndex: any = this.dependentTables.NahradniDily.cellNames?.PC;
			newRow.cells[pcIndex] = this.pcInput;
			const ndpIndex: number = this.dependentTables.NahradniDily.cellNames!.NDP;
			newRow.cells[ndpIndex] = this.ndpInput;
			const discountIndex: any = this.dependentTables.NahradniDily.cellNames?.SLEVA;

			const partIndex: number = this.dependentTables.NahradniDily.cellNames!.ND_NR;
			const ndNrIndex: number = this.dependentTables.NahradniDily.cellNames!.ND_NR;
			newRow.cells[ndNrIndex] = this.selectedPartNumber;
			const part = newRow.cells[ndNrIndex];
			const wearIndex: number = this.dependentTables.NahradniDily.cellNames!.VYROBEKND_OZN;
			let brand = newRow.cells[wearIndex];
			let wearHouse = newRow.cells[stockIndex];
			if(wearHouse == null || wearHouse === undefined || _.isNil(wearHouse) || wearHouse == '') {

				 this.showErrorAlert({
					message: this.LocalizeChyboveHlasky('PLEASE_ENTER_REQUIRED_VALUES_FOR_PARTS'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: {
						type: 'info',
					},
				});
				return;
			}

			if (newRow.cells[discountIndex] > MAX_DISCOUNT_LIMIT || newRow.cells[discountIndex] < MIN_DISCOUNT_LIMIT) {
				newRow.cells[discountIndex] = 0;
				return this.showErrorAlert({
					message: this.LocalizeChyboveHlasky('msgNotMoreDiscThn100Per'),
					options: { type: 'error' },
					localizeMessage: false,
				});
			}
			if (_.isNull(brand) || _.isNull(wearHouse) || _.isNull(stockIndex) || _.isNull(ndpIndex)
				|| _.isNull(part) || _.isNull(wearIndex) || _.isNull(pcIndex) || _.isNull(partIndex)) {
				return false;
			}
			if (this.checkForDiscountLimit(true, newRow.cells[discountIndex], newRow) !== true) {
				newRow.cells[discountIndex] = 0;
				return false;
			}
			const quantityInputIndex: number = this.dependentTables.NahradniDily.cellNames!.MNOZSTVI_SJ;
			const partQuantityIndex: number = this.dependentTables.NahradniDily.cellNames!.PART_QUANTITY;
			let quantity = newRow.cells[quantityInputIndex];

			if (newRow.cells[quantityInputIndex] < 0) {
				newRow.cells[quantityInputIndex] = 0;
				return this.showErrorAlert({
					message: this.LocalizeChyboveHlasky('quantityShouldNotBeInNegative'),
					options: { type: 'error' },
					localizeMessage: false,
				});
			}
			

			if (!brand || brand !== this.brandInput) {
				brand = this.brandInput;
				newRow.cells[wearIndex] = this.brandInput;
			}
			if (!wearHouse) {
				wearHouse = this.stockInput;
			}
			
			const unit = await this.GetConversionUnitsForPart(part, brand, wearHouse);
		    if (!_.isNil(part) && !_.isNil(wearHouse) && !_.isNil(quantity) && wearHouse !== '')
			{
				if(quantity === '')
				{
					quantity = DefualtQuantity ;
				}
				const { data: isObsoletePartStock } = await partApiProvider.getisObsoletePartStock(part, wearHouse, brand, quantity);
				this.showObsoleteErrorMsg(isObsoletePartStock, newRow, ndNrIndex);
			}
			this.$store.commit(`${this.storeUri}/${END_LOADING}`);
			let iTotalTimeTaken = performance.now() - startTime;
			let seconds = parseFloat((iTotalTimeTaken / 1000).toFixed(2));
			await OZakazkaProvider.logPerformance('PlannedOrderPrp', `Planned Order: ${this.OzakazkaId!}`, PART_ROW_SAVED , seconds);
			return true;
		},
		async showObsoleteErrorMsg(isObsoletePartStock: any, newRow: Row, ndNrIndex: number) {
			if (isObsoletePartStock.IsObsoletePart) {
				const replacement = [{
					key: '<SUPERSEDED_PART_NUMBER>',
					value: isObsoletePartStock.SupersededPartNumber,
				},
				{
					key: '<SUPERSEDED_DATE>',
					value: isObsoletePartStock.SupersededDate,
				}];
				if (isObsoletePartStock.IsQuantityAvailable && !_.isNil(isObsoletePartStock.SupersededPartNumber)) {
					const confirmChangePart = await this.showConfirm({
						message: this.LocalizeAndReplaceMultiple(
							this.LocalizeChyboveHlasky('msgPartObsoleteSuperseded'),
							replacement,
						),
						title: this.LocalizeChyboveHlasky('questionTitle'),
						options: {
							confirmButtonText: this.Localize('Ano'),
							cancelButtonText: this.Localize('Ne'),
							closeOnPressEscape: false,
							closeOnClickModal: false,
						},
					});
					if (confirmChangePart) {
						this.$store.commit(`${this.storeUri}/${START_LOADING}`);
						newRow.cells[ndNrIndex] = isObsoletePartStock.SupersededPartNumber;
						this.selectedPartNumber = isObsoletePartStock.SupersededPartNumber;
						this.partNumberChangeMethod(isObsoletePartStock.SupersededPartNumber, newRow, ndNrIndex);
						this.$store.commit(`${this.storeUri}/${END_LOADING}`);
					}
				} else if (!isObsoletePartStock.IsQuantityAvailable && !_.isNil(isObsoletePartStock.SupersededPartNumber)) {
					const confirmChangePart = await this.showConfirm({
						message: this.LocalizeAndReplaceMultiple(
							this.LocalizeChyboveHlasky('msgPartObsoleteSupersededQuantity'),
							replacement,
						),
						title: this.LocalizeChyboveHlasky('questionTitle'),
						options: {
							confirmButtonText: this.Localize('Ano'),
							cancelButtonText: this.Localize('Ne'),
							closeOnPressEscape: false,
							closeOnClickModal: false,
						},
					});
					if (confirmChangePart) {
						this.$store.commit(`${this.storeUri}/${START_LOADING}`);
						newRow.cells[ndNrIndex] = isObsoletePartStock.SupersededPartNumber;
						this.selectedPartNumber = isObsoletePartStock.SupersededPartNumber;
						this.partNumberChangeMethod(isObsoletePartStock.SupersededPartNumber, newRow, ndNrIndex);
						this.$store.commit(`${this.storeUri}/${END_LOADING}`);
					} else {
						newRow.cells[ndNrIndex] = '';
						this.selectedPartNumber = '';
					}
				} else if (!isObsoletePartStock.IsQuantityAvailable && _.isNil(isObsoletePartStock.SupersededPartNumber)) {
					newRow.cells[ndNrIndex] = '';
					this.selectedPartNumber = '';
					this.showErrorAlert({
						message: this.LocalizeChyboveHlasky('msgIsObsoleteQuantityNotAvailable'),
						options: { type: 'error' },
						localizeMessage: false,
					});
				}
			}
		},
		isDecimal(num: number) {
			return (num % 1);
		},
		rowCancel(row: any) {
			if (row !== undefined) {
				const textIndex: any = this.dependentTables.NahradniDily.cellNames?.TEXT;
				const pcIndex: any = this.dependentTables.NahradniDily.cellNames?.PC;
				const localRrpIndex: number = this.dependentTables.NahradniDily.cellNames!.LOCAL_RRP_ID;
				const rrpUnitPriceIndex: number = this.dependentTables.NahradniDily.cellNames!.RRP_UNIT_PRICE;
				const ndpIndex: number = this.dependentTables.NahradniDily.cellNames!.NDP;
				const stockIndex: number = this.dependentTables.NahradniDily.cellNames!.STOCK;
				if (row.row !== undefined) {
					if (this.cancelDescriptionInput !== row.row.cells[textIndex]) {
						this.descriptionInput = this.cancelDescriptionInput;
						row.row.cells[textIndex] = this.cancelDescriptionInput;
					}

					if (this.cancelPcInput !== row.row.cells[pcIndex]) {
						this.pcInput = this.cancelPcInput;
						row.row.cells[pcIndex] = this.cancelPcInput;

						this.localRrpInput = this.canceLocalRrpInput;
						row.row.cells[localRrpIndex] = this.canceLocalRrpInput;

						this.rrpUnitPriceInput = this.cancelRrpunitPriceInput;
						row.row.cells[rrpUnitPriceIndex] = this.cancelRrpunitPriceInput;

						this.cancelNdpInput = this.cancelNdpInput;
						row.row.cells[ndpIndex] = this.cancelNdpInput;

						this.stockInput = this.cancelStockInput;
						row.row.cells[stockIndex] = this.cancelStockInput;
					}
				}
			}
		},
		onTextInput(event: any, row: Row, columnId: number) {
			this.descriptionInput = event;
			row.cells[columnId] = event;
		},
		async onRrpUnitPriceChange(value: any, row: Row, columnId: number, updateCol: any) {			
			updateCol(value, columnId);					
			row.cells[columnId] = value;
		},
		async onRrpUnitPriceLeave(value: any, row: Row, columnId: number, updateCol: any) {
			if (value <= 0 || value === null) {					
					this.showErrorAlert({
					message: this.LocalizeChyboveHlasky('msgCorrectUnitPrice'),
					options: { type: 'error' },
					localizeMessage: false,
				});
					row.cells[columnId] = this.rrpUnitPriceInput;					
					return false;
			}
			updateCol(value, columnId);	
			this.rrpUnitPriceInput = value;				
			row.cells[columnId] = value;
		},
		onPcInput(event: any, row: Row, columnId: number) {
			this.pcInput = event;
			row.cells[columnId] = event;
			const pcIndex: any = this.dependentTables.NahradniDily.cellNames?.CONVERTED_QUANTITY;
			row.cells[pcIndex] = event / this.convertedQuantity;

		},
		getVyrobekndOznDetails(row: Row, columnId: number) {
			const result: any = this.dropdownList.VyrobekndOzn.find((item: any) => item.Value === row.cells[columnId]);
			return result?.Text;
		},
		async vyrobekndOznChangeMethod(val: string, row: Row) {
			const textIndex: any = this.dependentTables.NahradniDily.cellNames?.TEXT;
			const unitIndex: any = this.dependentTables.NahradniDily.cellNames?.BASE_UNIT_OF_MEASUREMENT;
			const pcIndex: any = this.dependentTables.NahradniDily.cellNames?.PC;
			const NdnrIndex: any = this.dependentTables.NahradniDily.cellNames?.ND_NR;
			this.descriptionInput = '';
			this.pcInput = '';
			row.cells[textIndex] = '';
			row.cells[unitIndex] = '';
			row.cells[pcIndex] = '';
			row.cells[NdnrIndex] = '';
			this.dropdownList.PartsLists = [];
			this.loadingDropdown = true;
			const stockIndex: number = this.dependentTables.NahradniDily.cellNames!.STOCK;
			this.loadingDropdown = false;
		},
		getPartNumberDetails(row: Row, columnId: number) {
			return row.cells[columnId];
		},
		getServiceJobDetails(row: Row, columnId: number) {
			const result: any = this.dropdownList.ServiceJobForItems.find((item: any) => item.Value === row.cells[columnId]);
			return result?.Text;
		},
		getTechnicianDetails(row: Row, columnId: number) {
			const result: any = this.dropdownList.TechiciansList.find(
				(item: any) => item.Value === parseInt(row.cells[columnId]),
			);
			return result?.Text;
		},
		onTechnicianChange(value :number, columnId: number, row : Row, updateCol : any) {
			updateCol(value, columnId);
			this.technicianId = value;
		},
		onPartDropdownSelect(value: string, row: Row, columnId: number) {
			this.isPartSelectionInProgress = true;
			this.selectedPartNumber = value;
			this.partNumberChangeMethod(value, row, columnId);
		},
		onPartNumberBlur(row: Row, columnId: number) {
			// If a dropdown selection already triggered the API call, skip the blur
			if (this.isPartSelectionInProgress) {
				this.isPartSelectionInProgress = false;
				return;
			}
			const trimmedValue = (this.selectedPartNumber || '').trim();
			// Skip if value hasn't changed from when editing started
			if (trimmedValue === this.previousPartNumber) {
				return;
			}
			// Skip if user cleared the input to empty
			if (!trimmedValue) {
				return;
			}
			this.partNumberChangeMethod(trimmedValue, row, columnId);
		},
		async partNumberChangeMethod(val: string, row: Row, columnId: number) {
			const startTime = performance.now();
			const partIndex: number = this.dependentTables.NahradniDily.cellNames!.ND_NR;
			this.ndNrInput = row.cells[partIndex];
			const part = row.cells[partIndex] = val;
			this.$store.commit(`${this.storeUri}/${START_LOADING}`);
			this.selectedPartNumber = val;
			this.previousPartNumber = val;
			const stockInd: number = this.dependentTables.NahradniDily.cellNames?.STOCK!;
			if(row.cells[stockInd] === null || row.cells[stockInd] === undefined || row.cells[stockInd] == '') {
				this.$store.commit(`${this.storeUri}/${END_LOADING}`);
				this.showErrorAlert({
						message: this.LocalizeChyboveHlasky('PLEASE_ENTER_REQUIRED_VALUES_FOR_PARTS'),
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						options: {
							type: 'info',
						},
					});
					return;
			}
			const brandInd: number = this.dependentTables.NahradniDily.cellNames?.VYROBEKND_OZN!;
			if(row.cells[stockInd] !== '' || row.cells[stockInd] === null || row.cells[stockInd] !== undefined) {
				//New API to fetch part details at once instead of multiple API calls in sequence
				this.$store.commit(`${this.storeUri}/${START_LOADING}`);
				const selectedPartData = await OZakazkaProvider.getRequiredDataForPartSelection({
					partNumber: val,
					warehouseId: row.cells[stockInd],
					plannedOrderId: this.OzakazkaId!,
					quantity: DefualtQuantity
				});
				this.$store.commit(`${this.storeUri}/${END_LOADING}`);
				//End of new API call
				if(!selectedPartData.data || (typeof selectedPartData.data === 'object' && Object.keys(selectedPartData.data).length === 0)) {
					this.$store.commit(`${this.storeUri}/${END_LOADING}`);
					this.selectedPartNumber = '';
					this.previousPartNumber = '';
					const partIdx: number = this.dependentTables.NahradniDily.cellNames!.ND_NR;
					row.cells[partIdx] = '';
					this.dropdownList.Parts = this.dropdownList.DefaultPartsList.slice(0, 100);
					return;
				}
				const result = selectedPartData?.data?.PART_DETAILS;// await OZakazkaProvider.getPartsPrice(val, this.OzakazkaId!, row.cells[stockInd]);
				if (result !== null && result !== undefined) {
					if (!row.cells[stockInd]) {
						row.cells[stockInd] = result?.SKLAD_OZN;
					}
					row.cells[brandInd] = result?.VYROBEKND_OZN;
				}
				this.brandInput = result?.VYROBEKND_OZN;
				this.stockInput = result?.SKLAD_OZN;
				this.MeasuringUnit = result?.VYDEJ_MJ_ID;

				const textIndex: any = this.dependentTables.NahradniDily.cellNames?.TEXT;
				const pcIndex: any = this.dependentTables.NahradniDily.cellNames?.PC;
				this.descriptionInput = result?.TEXT;
				row.cells[textIndex] = result?.TEXT;
				this.pcInput = result?.PC;
				row.cells[pcIndex] = result?.PC;
				const partCategoryIndex: any = this.dependentTables.NahradniDily.cellNames?.VYROBEKND_OZN;
				const DefaultLocalRrpIndex: number = this.dependentTables.NahradniDily.cellNames!.LOCAL_RRP_ID;
				if (this.OzakazkaId !== null || this.OzakazkaId !== undefined && (row.cells[stockInd] !== '' || row.cells[stockInd] !== null || row.cells[stockInd] !== undefined)) {
					const localRrpList = selectedPartData?.data?.PRICING_LIST;//await OZakazkaProvider.getPricingDate(val, row.cells[partCategoryIndex], this.OzakazkaId, row.cells[stockInd]);
					if (localRrpList !== null || localRrpList !== undefined) {
						this.dropdownList.Mrp = localRrpList;
						row.cells[DefaultLocalRrpIndex] = localRrpList.length > 0 ? localRrpList[0].Value : 0;
					}
				}
				const ndpIndex: number = this.dependentTables.NahradniDily.cellNames!.NDP;
				const resultForNdp = selectedPartData?.data?.NDP;//await OZakazkaProvider.getNdpPricing(row.cells[DefaultLocalRrpIndex], val, row.cells[partCategoryIndex], row.cells[stockInd]);
				if (resultForNdp !== null || resultForNdp !== undefined) {
					row.cells[ndpIndex] = resultForNdp;
				}
				this.ndpInput = row.cells[ndpIndex];
				this.localRrpInput = row.cells[DefaultLocalRrpIndex];
				const stockIndex: number = this.dependentTables.NahradniDily.cellNames!.STOCK;
				const partQuantityIndex: number = this.dependentTables.NahradniDily.cellNames?.PART_QUANTITY!;
				row.cells[partQuantityIndex] = 0;
				const getPartQuantityData = selectedPartData?.data?.PART_QUANTITY;//await OZakazkaProvider.getPartQuantity(val, row.cells[partCategoryIndex], row.cells[stockIndex]);
				if (getPartQuantityData !== null || getPartQuantityData !== undefined) {
					row.cells[partQuantityIndex] = getPartQuantityData;
				}
				const unit = result?.data?.UnitOfMeasure;
				if (unit) {
					const unitText = (this.dropdownList.MeasuringUnit.find((item: any) => item.Value === this.MeasuringUnit!) as any)?.Text ?? '';
					const baseUnitOfMeasurement: number = this.dependentTables.NahradniDily.cellNames!.BASE_UNIT_OF_MEASUREMENT;
					const unitOfMeasurement: number = this.dependentTables.NahradniDily.cellNames!.CONVERTED_UNIT_OF_MEASUREMENT;
					row.cells[baseUnitOfMeasurement] = `${unit} (${'1'} ${unit} ${'='} ${this.expandedUnit} ${unitText})`;
					row.cells[unitOfMeasurement] = unitText;
				}
				const DefaultRrpUnitPriceIndex: number = this.dependentTables.NahradniDily.cellNames!.RRP_UNIT_PRICE;

				const RrpUnitPrice = selectedPartData?.data?.RRP_UNIT_PRICE;//await OZakazkaProvider.getRrpUnitPrice(val, row.cells[partCategoryIndex], row.cells[stockInd]);		
				if (RrpUnitPrice !== null || RrpUnitPrice !== undefined) {
					row.cells[DefaultRrpUnitPriceIndex] = RrpUnitPrice;
				}
				this.rrpUnitPriceInput = row.cells[DefaultRrpUnitPriceIndex];
				const quantityInputIndex: number = this.dependentTables.NahradniDily.cellNames!.MNOZSTVI_SJ;
				if (!_.isNil(part) && !_.isNil(row.cells[stockInd]) && row.cells[stockInd] !== '') {
					if (row.cells[quantityInputIndex] === '' || _.isNil(row.cells[quantityInputIndex])) {
						row.cells[quantityInputIndex] = DefualtQuantity;
					}
					const isObsoletePartStock = selectedPartData?.data?.OBSOLETE_INFO;//await partApiProvider.getisObsoletePartStock(part, row.cells[stockInd], row.cells[partCategoryIndex],
						//row.cells[quantityInputIndex]);
					this.showObsoleteErrorMsg(isObsoletePartStock, row, partIndex);
				}
			}
			this.$store.commit(`${this.storeUri}/${END_LOADING}`);
			let iTotalTimeTaken = performance.now() - startTime;
			let seconds = parseFloat((iTotalTimeTaken / 1000).toFixed(2));
			await OZakazkaProvider.logPerformance('PlannedOrderPrp', `Planned Order: ${this.OzakazkaId!}`, PART_SELECTED, seconds);
		},
		async localRrpChangeMethod(val: number, row: Row, columnId: number) {
			const stockInd: number = this.dependentTables.NahradniDily.cellNames?.STOCK!;
			const DefaultLocalRrpIndex: number = this.dependentTables.NahradniDily.cellNames!.LOCAL_RRP_ID;
			const unitPriceIndex: number | undefined = this.dependentTables.NahradniDily.cellNames?.UNIT_PRICE_;
			const partCategoryIndex: number = this.dependentTables.NahradniDily.cellNames!.VYROBEKND_OZN;
			const ndpIndex: number = this.dependentTables.NahradniDily.cellNames!.NDP;
			const partNumberIndex: number = this.dependentTables.NahradniDily.cellNames!.ND_NR;
			if (unitPriceIndex !== undefined) {
				const selected: any = this.dropdownList.Mrp.find((item: any) => item.Value === val);
				row.cells[unitPriceIndex] = selected?.Text ?? '';
			}
			if(row.cells[stockInd] == '' || row.cells[stockInd] == null || row.cells[stockInd] == undefined) {
				const { data: resultForNdp } = await OZakazkaProvider.getNdpPricing(val, row.cells[partNumberIndex], row.cells[partCategoryIndex], row.cells[stockInd]);
				if (resultForNdp !== null || resultForNdp !== undefined) {
					row.cells[ndpIndex] = resultForNdp;
				}
				this.ndpInput = row.cells[ndpIndex];
				this.localRrpInput = row.cells[DefaultLocalRrpIndex];
			}
		},
		getLocalRrpDetails(row: Row, columnId: number) {
			const unitPriceIndex: number | undefined = this.dependentTables.NahradniDily.cellNames?.UNIT_PRICE_;
			if (unitPriceIndex !== undefined && row.cells[unitPriceIndex]) {
				return row.cells[unitPriceIndex];
			}
			const mrpResult: any = this.dropdownList.Mrp.find((item: any) => item.Value === row.cells[columnId]);
			return mrpResult?.Text;
		},
		disableColumns(table: Table | Column) {
			_.forEach(table.columns, (col) => {
				col.isVisible = this.columns.has(col.columnName);
				if (this.dmsSys.EnableGSTPrp) {
					if (col.columnName === 'PC_VC_DPH_NAD' || col.columnName === 'PC_BEZ_DPH_NAD') {
						col.isVisible = false;
					}
				} else if (col.columnName === 'PC_WITH_GST' || col.columnName === 'PC_WITHOUT_GST') {
					col.isVisible = false;
				}

				if (_.has(col, 'columns')) {
					this.disableColumns(col);
				}
			});
		},
		async GetConversionUnitsForPart(partNumber: string, brand: string, wearHouse: number) {
			const { data } = await partApiProvider.getConversionUnits(partNumber, wearHouse, brand);
			this.expandedUnit = data.ExpandedUnit;
			this.convertedQuantity = data.ExpandedUnit;
			return data.UnitOfMeasure;
		},
		createND() {
			openEdit(
				NAME,
				PageMode.CREATE,
				{
					props: true,
					filter: {
						OzakazkaId: this.OzakazkaId,
					},
				},
			);
		},
		createClickFunc() {
			openEdit(
				NAME,
				PageMode.CREATE,
				{ props: true, filter: { OzakazkaId: this.OzakazkaId } },
			);
		},
		editClick(event: any) {
			openEdit(NAME, PageMode.EDIT, { props: true, id: event.data.ID });
		},
		async deleteRow(item: any) {
				const confirmDelete = await this.showConfirm({
				message: this.LocalizeChyboveHlasky('SURE_TO_DELETE'),
				title: this.LocalizeChyboveHlasky('SURE_TO_DELETE_CONFIRM'),
				options: {
						confirmButtonText: this.Localize('Ano'),
						cancelButtonText: this.Localize('Ne'),
					},
				});
				if (confirmDelete) {
					this.$store.commit(`${this.storeUri}/${START_LOADING}`);
					await OZakazkaProvider.deletePart(item.rowId)
					await this.fetchTableData([ND]);
					this.$store.commit(`${this.storeUri}/${END_LOADING}`);
			}
		},
	},
});
